import { __extends, __spreadArray } from 'tslib';
import React__default from 'react';
import throttle from 'lodash.throttle';
import { Tabs } from '../Tabs/Tabs.component.js';
import ScrollNavSection from './ScrollNavSection.component.js';
import { propTypes } from './ScrollNav.types.js';
import { calculateOffset, ScrollNavContext } from './ScrollNav.utils.js';
import styles from './ScrollNav.module.scss.js';

var ScrollNav = /** @class */ (function (_super) {
    __extends(ScrollNav, _super);
    function ScrollNav(props) {
        var _this = _super.call(this, props) || this;
        _this.observe = function (ref, id, title, testId) {
            _this.setState(function (prevState) {
                var _a, _b;
                return ({
                    sections: __spreadArray(__spreadArray([], prevState.sections, true), [{ ref: ref, id: id, title: title, testId: testId }], false),
                    activeSection: ((_b = (_a = prevState.sections) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.id) || '',
                });
            }, function () {
                _this.offsets = _this.state.sections.map(function (section, index) {
                    return calculateOffset({
                        section: section,
                        index: index,
                        allSections: _this.state.sections,
                        maxScroll: document.body.scrollHeight - window.innerHeight,
                        scrollTop: document.documentElement.scrollTop,
                        defaultOffsetTop: _this.props.offsetTop,
                    });
                });
            });
        };
        _this.handleScroll = function () {
            var matchingSections = _this.offsets.filter(function (offset) { return window.pageYOffset >= offset.offset; });
            var activeSection = matchingSections[matchingSections.length - 1];
            if (_this.state.activeSection !== activeSection.id) {
                _this.setState({
                    activeSection: activeSection.id,
                });
            }
        };
        _this.handleResize = function () {
            _this.hasScrollBar = document.body.scrollHeight > window.innerHeight;
            _this.offsets = _this.state.sections.map(function (section, index) {
                return calculateOffset({
                    section: section,
                    index: index,
                    allSections: _this.state.sections,
                    maxScroll: document.body.scrollHeight - window.innerHeight,
                    scrollTop: document.documentElement.scrollTop,
                    defaultOffsetTop: _this.props.offsetTop,
                });
            });
            _this.handleScroll();
        };
        _this.handleAnchorClick = function (sectionId) {
            var _a;
            history.pushState(null, '', "#" + sectionId);
            if (!_this.hasScrollBar) {
                _this.setState({
                    activeSection: sectionId,
                });
                return;
            }
            window.scrollTo({
                top: (_a = _this.offsets.find(function (offset) { return offset.id === sectionId; })) === null || _a === void 0 ? void 0 : _a.offset,
                behavior: 'smooth',
            });
        };
        _this.state = {
            activeSection: '',
            sections: [],
        };
        _this.offsets = [];
        _this.hasScrollBar = true;
        _this.throttledHandleScroll = throttle(_this.handleScroll, 50);
        _this.throttledHandleResize = throttle(_this.handleResize, 500);
        return _this;
    }
    ScrollNav.prototype.componentDidMount = function () {
        this.hasScrollBar = document.body.scrollHeight > window.innerHeight;
        window.addEventListener('scroll', this.throttledHandleScroll);
        window.addEventListener('resize', this.throttledHandleResize);
    };
    ScrollNav.prototype.componentWillUnmount = function () {
        window.removeEventListener('scroll', this.throttledHandleScroll);
        window.removeEventListener('resize', this.throttledHandleResize);
    };
    ScrollNav.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, children = _a.children, offsetTop = _a.offsetTop, navigationOffsetTopProp = _a.navigationOffsetTop;
        var _b = this.state, sections = _b.sections, activeSection = _b.activeSection;
        var navigationOffsetTop = offsetTop || navigationOffsetTopProp;
        return (React__default.createElement(ScrollNavContext.Provider, { value: { observe: this.observe } },
            React__default.createElement("div", { className: styles.ScrollNav + " " + (className || '') },
                sections && (React__default.createElement("div", { className: styles.ScrollNav_sections, style: navigationOffsetTop
                        ? { top: navigationOffsetTop }
                        : undefined },
                    React__default.createElement(Tabs, { vertical: true, active: activeSection, onSelect: function (name) {
                            _this.handleAnchorClick(name);
                        } }, sections.map(function (section) {
                        return (React__default.createElement(Tabs.Tab, { key: section.id, name: section.id, "data-testid": section.testId + "Tab" }, section.title));
                    })))),
                React__default.createElement("div", { className: styles.ChildrenContainer }, children))));
    };
    ScrollNav.displayName = 'ScrollNav';
    ScrollNav.propTypes = propTypes;
    ScrollNav.Section = ScrollNavSection;
    return ScrollNav;
}(React__default.Component));

export { ScrollNav, ScrollNav as default };
